
import { Component, Vue } from 'vue-property-decorator';

import Swal from 'sweetalert2';

import freeDomains from '../freeEmailProviderDomains';
import { RegistrationRequest } from '../models';
import { httpPost } from '../utils';

@Component
export default class RegistrationView extends Vue {
  private isLoading: boolean = false;
  private loginUrl: string = process.env.VUE_APP_LOGIN_URL!;
  private emailAddress: string = '';
  private companyName: string = '';
  private firstName: string = '';
  private lastName: string = '';
  private jobTitle: string = '';
  private phoneNumber: string = '';

  get emailAddressIsPresent(): boolean {
    return this.emailAddress.length > 0;
  }

  get emailAddressDomain(): string {
    const substrings = this.emailAddress.split('@');
    if (substrings.length === 2) {
      return substrings[1];
    }
    return '';
  }

  get emailAddressDomainIsPresent(): boolean {
    return this.emailAddressDomain.length > 0;
  }

  get emailAddressDomainIsAllowed(): boolean {
    return !freeDomains.includes(this.emailAddressDomain);
  }

  get emailAddressIsValid(): boolean {
    return this.emailAddressIsPresent && this.emailAddressDomainIsPresent && this.emailAddressDomainIsAllowed;
  }

  get companyNameIsValid(): boolean {
    return this.companyName.length > 0;
  }

  get firstNameIsValid(): boolean {
    return this.firstName.length > 0;
  }

  get lastNameIsValid(): boolean {
    return this.lastName.length > 0;
  }

  get jobTitleIsValid(): boolean {
    return this.jobTitle.length > 0;
  }

  get phoneNumberIsValid(): boolean {
    return this.phoneNumber.length > 0;
  }

  get formIsValid(): boolean {
    return this.emailAddressIsValid &&
      this.companyNameIsValid &&
      this.firstNameIsValid &&
      this.lastNameIsValid &&
      this.jobTitleIsValid &&
      this.phoneNumberIsValid;
  }

  private submit() {
    if (!this.formIsValid) {
      return;
    }
    const url = `${process.env.VUE_APP_API_HOST}/registration`;
    const data: RegistrationRequest = {
      emailAddress: this.emailAddress,
      companyName: this.companyName,
      firstName: this.firstName,
      lastName: this.lastName,
      jobTitle: this.jobTitle,
      phoneNumber: this.phoneNumber,
    };
    this.isLoading = true;
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response.ok) {
        Swal.fire({
          title: 'Registration Successful',
          text: `A confirmation email will be sent to ${this.emailAddress}`,
          type: 'success',
        });
      } else {
        throw new Error('Error during registration');
      }
    }).catch((error) => {
      Swal.fire({
        title: 'Registration Error',
        text: error.message,
        type: 'error',
      });
    }).then(() => {
      this.isLoading = false;
    });
  }
}
